/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type VisionOnboardingCompleteMutationVariables = Types.Exact<{
  [key: string]: never;
}>;
export type VisionOnboardingCompleteMutation = {
  __typename?: "Mutation";
  visionOnboardingComplete?: {
    __typename?: "VisionOnboardingCompletePayload";
    result: {
      __typename?: "VisionOnboardingCompleteError";
      message: string;
    } | {
      __typename?: "VisionOnboardingCompleteSuccess";
      isOptedInToRecurringLooks: boolean;
    };
  } | null;
};
export const VisionOnboardingCompleteDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "visionOnboardingComplete"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "visionOnboardingComplete"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionOnboardingCompleteSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "isOptedInToRecurringLooks"
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "VisionOnboardingCompleteError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "message"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type VisionOnboardingCompleteMutationFn = Apollo.MutationFunction<VisionOnboardingCompleteMutation, VisionOnboardingCompleteMutationVariables>;

/**
 * __useVisionOnboardingCompleteMutation__
 *
 * To run a mutation, you first call `useVisionOnboardingCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisionOnboardingCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visionOnboardingCompleteMutation, { data, loading, error }] = useVisionOnboardingCompleteMutation({
 *   variables: {
 *   },
 * });
 */
export function useVisionOnboardingCompleteMutation(baseOptions?: Apollo.MutationHookOptions<VisionOnboardingCompleteMutation, VisionOnboardingCompleteMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<VisionOnboardingCompleteMutation, VisionOnboardingCompleteMutationVariables>(VisionOnboardingCompleteDocument, options);
}
export type VisionOnboardingCompleteMutationHookResult = ReturnType<typeof useVisionOnboardingCompleteMutation>;
export type VisionOnboardingCompleteMutationResult = Apollo.MutationResult<VisionOnboardingCompleteMutation>;
export type VisionOnboardingCompleteMutationOptions = Apollo.BaseMutationOptions<VisionOnboardingCompleteMutation, VisionOnboardingCompleteMutationVariables>;